import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { StorageService } from '../../../services/storage/storage.service';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../services/common/common.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

declare var require: any;
var CryptoJS = require('crypto-js');

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	user_details: any;

	financial_institution: any = "";

	current_url: string = "";

	type: any = "";
	tab: any = "";

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private authService: AuthService,
		private datePipe: DatePipe,
		private dialog: MatDialog,
		private router: Router,
		private route: ActivatedRoute,
	) { }

	ngOnInit(): void {

		this.getUserData();


		this.route.params.subscribe((params) => {
			this.type = params['type'];
			this.tab = params['tab'];
		});

		if (this.tab == "manage-profile") {
			this.selected_tab = "Manage Profile";
		} else if (this.tab == "change-password") {
			this.selected_tab = "Change Password";
		} else if (this.tab == "mail-configuration") {
			this.selected_tab = "Mail Configuration";
		} else if (this.tab == "notifications") {
			this.selected_tab = "Notifications";
		} else if (this.tab == "integrations") {
			this.selected_tab = "Integrations";
		} else {
			this.selected_tab = "Manage Profile";
		}

		this.current_url = window.location.href;

		// this.user_details = JSON.parse(JSON.stringify(this.storageService.get('user_details')));
		// this.financial_institution = this.storageService.get("user_details").financial_institution
		// this.user_details.date_of_birth = this.datePipe.transform(this.user_details.date_of_birth, 'MM/dd/yyyy',);

		// if (this.user_details.role.role == 5 || this.user_details.role.role == 6) {
		// 	this.getAdvisorData();
		// }

		// this.getStates();
		// this.getGenders();
		// this.getAdvisorStatus();
		// this.getRegion();
		// this.getLicenses();
		// this.getCertificates();
		// this.getProfessionalAssociations();
		// this.getAdvisorTypes();
		// this.calculateYears();
		// this.getEmploymentTypes();
		// this.getDesignations();
		// this.getProductGroups();

	}

	profile_data_loaded: boolean = false;
	getUserData() {
		let userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const payload = {
		  role: ""
		};

		this.profile_data_loaded = false;

		this.commonService.postData('/authenticatedUser/?timezone=' + userTimezone, payload).subscribe(
			(res: any) => {
				this.storageService.set("user_details", res);

				this.user_details = JSON.parse(JSON.stringify(res));
				this.financial_institution = this.storageService.get("user_details").financial_institution
				this.user_details.date_of_birth = this.datePipe.transform(this.user_details.date_of_birth, 'MM/dd/yyyy',);

				if (this.user_details.role.role == 5 || this.user_details.role.role == 6) {
					this.getAdvisorData();
				}

				this.getStates();
				this.getGenders();
				this.getAdvisorStatus();
				this.getRegion();
				this.getLicenses();
				this.getCertificates();
				this.getProfessionalAssociations();
				this.getAdvisorTypes();
				this.calculateYears();
				this.getEmploymentTypes();
				this.getDesignations();
				this.getProductGroups();

				this.getServicesOffered();

				this.generateTimeSlots();
				this.generateTimeZones();

				// return res;

				this.profile_data_loaded = true;
			},
			(err) => {
				this.authService.logout();
			  	this.router.navigate(['/login']);
			},
		);
	}

	states_list: any = [];
	getStates() {
		this.commonService.getData('/state?no_page=true/').subscribe(
			(res: any) => {
				this.states_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	genders_list: any = [];
	getGenders() {
		this.commonService.getData('/gender?no_page=true/').subscribe(
			(res: any) => {
				this.genders_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisor_status_list: any = [];
	getAdvisorStatus() {
		this.commonService.getData('/advisorStatus?no_page=true/').subscribe(
			(res: any) => {
				this.advisor_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	region_list: any = [];
	getRegion() {
		let route: any = "/region?no_page=true";
		if (this.user_details.role.role != 1 && this.user_details.role.role != 10) {
			route = route + "&financial_institution=" + this.financial_institution;
		}
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.region_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	licenses_list: any = [];
	getLicenses() {
		this.commonService.getData('/licenses?no_page=true/').subscribe(
			(res: any) => {
				this.licenses_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	certificates_list: any = [];
	getCertificates() {
		this.commonService.getData('/certificates?no_page=true/').subscribe(
			(res: any) => {
				this.certificates_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	professional_associations_list: any = [];
	getProfessionalAssociations() {
		this.commonService.getData('/professionalAssociations?no_page=true/').subscribe(
			(res: any) => {
				this.professional_associations_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	advisor_type_list: any = [];
	getAdvisorTypes() {
		this.commonService.getData('/advisorType?no_page=true/').subscribe(
			(res: any) => {
				this.advisor_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	represent_years: any = [];
	calculateYears() {
		let current_year = new Date().getFullYear();
		const limit = 70;
		for (let index = 0; index < limit; index++) {
			this.represent_years.push(current_year);
			current_year = current_year - 1;
		}
	}

	employment_type_list: any = [];
	getEmploymentTypes() {
		this.commonService.getData('/employmentType?no_page=true/').subscribe(
			(res: any) => {
				this.employment_type_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	designation_list: any = [];
	getDesignations() {
		this.commonService.getData('/designation?no_page=true/').subscribe(
			(res: any) => {
				this.designation_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_group_list: any = [];
	getProductGroups() {
		if(this.financial_institution != null) {
			let route = '/productGroup?financial_institution=' + this.financial_institution + '&no_page=true/'
			this.commonService.getData(route).subscribe(
				(res: any) => {
					this.product_group_list = res;
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		} else{
			this.product_group_list = []
		}
	}

	services_offered_list: any = [];
	getServicesOffered() {
		this.commonService.getData('/servicesOffered?no_page=true/').subscribe(
		(res: any) => {
			this.services_offered_list = res;
		},
		(err) => {
			this.commonService.showToast('error', err.error);
		},
		);
	}

	selected_tab: any = 'Manage Profile';
	changeTab(value) {
		this.selected_tab = value;

		let role: any = "";

		if (this.user_details.role.role == 1) {
			role = '/admin';
		} else if (this.user_details.role.role == 2) {
			role = '/admin';
		} else if (this.user_details.role.role == 3) {
			role = '/executive';
		} else if (this.user_details.role.role == 4) {
			role = '/advisor-manager';
		} else if (this.user_details.role.role == 5) {
			role = '/advisor';
		} else if (this.user_details.role.role == 6) {
			role = '/afa';
		} else if (this.user_details.role.role == 7) {
			role = '/assistant';
		} else if (this.user_details.role.role == 8) {
			role = '/relationship-manager';
		} else if (this.user_details.role.role == 10) {
			role = '/leadership';
		} else if (this.user_details.role.role == 11) {
			// role = '/marketing-team';
			role = '/opportunity';
		} else if (this.user_details.role.role == 12) {
			role = '/wholesaler';
		} else if (this.user_details.role.role == 13) {
			role = '/lending-officer';
		} else if (this.user_details.role.role == 14) {
      this.router.navigate(['/insurance-agent']);
    }

		if (this.selected_tab == "Manage Profile") {
			this.router.navigate([role + '/profile/manage-profile']);
		} else if (this.selected_tab == "Change Password") {
			this.router.navigate([role + '/profile/change-password']);
		} else if (this.selected_tab == "Mail Configuration") {
			this.router.navigate([role + '/profile/mail-configuration']);
		} else if (this.selected_tab == "Notifications") {
			this.router.navigate([role + '/profile/notifications']);
		} else if (this.selected_tab == "Integrations") {
			this.router.navigate([role + '/profile/integrations']);
		}


	}

	validEmail(email) {
		if (email != '' && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
			return true;
		} else {
			return false;
		}
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	validatePhoneNumber(number) {
		// Method 1
		// const regex = /^[\+][(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/gm;
		// if (number == null || number == '') {
		//   return false;
		// }

		// if (regex.test(number) == true) {
		//   return true;
		// } else {
		//   return false;
		// }

		// Method 2
		// const regex = /^\+\d{1,3}\s?\d{4,14}$/;
		// return regex.test(number);

		// Method 3
		const regex = /^\+\d{1,3}\s\(\d{3}\)\s\d{3}-\d{4}$/;
    	return regex.test(number);
	}

	formatPhoneNumber(event: Event): void {
		const input = event.target as HTMLInputElement;
		let value = input.value.replace(/\D/g, '');

		// Logic to determine the country code length
		let countryCodeLength = this.determineCountryCodeLength(value);
		let country = '+' + value.substr(0, countryCodeLength);
		value = value.substr(countryCodeLength);

		// Format the remaining number based on your desired pattern
		// This is an example; adjust the logic according to your needs
		let formattedNumber = this.formatRemainingNumber(value);

		input.value = country + ' ' + formattedNumber;
	}

	determineCountryCodeLength(number: string): number {
		// Example logic: adjust based on your requirements
		if (number.startsWith('1') || number.startsWith('7')) { // e.g., USA, Russia
			return 1;
		} else if (number.startsWith('20') || number.startsWith('44')) { // e.g., Egypt, UK
			return 2;
		} else {
			// Default to 3-digit country code
			return 3;
		}
	}

	formatRemainingNumber(number: string): string {
		// Implement your number formatting logic here
		// This is a placeholder example
		if (number == "" || number == null) {
			return ""
		} else {
			let area = number.substr(0, 3);
			let prefix = number.substr(3, 3);
			let line = number.substr(6, 4);
			return '(' + area + ') ' + prefix + (line ? '-' + line : '');
		}
	}

	password_details: any = {
		old: '',
		new: '',
		confirm: '',
	};
	password_details_errors: any = {
		old: false,
		new: false,
		confirm: false,
	};

	is_old_password_active: boolean = true;
	is_new_password_active: boolean = true;
	is_confirm_password_active: boolean = true;

	valid_password_length: boolean = false;
	checkPasswordLength(password) {
		if (password.length > 7) {
			this.valid_password_length = true;
			return true;
		} else {
			this.valid_password_length = false;
			return false;
		}
	}

	valid_password_uppercase: boolean = false;
	checkPasswordUppercase(password) {
		this.valid_password_uppercase = /[A-Z]/.test(password);
		return /[A-Z]/.test(password);
	}

	valid_password_lowercase: boolean = false;
	checkPasswordLowercase(password) {
		this.valid_password_lowercase = /[a-z]/.test(password);
		return /[a-z]/.test(password);
	}

	valid_password_special: boolean = false;
	checkPasswordSpecial(password) {
		this.valid_password_special = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
		return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(password);
	}

	valid_password_number: boolean = false;
	checkPasswordNumber(password) {
		this.valid_password_number = /\d/.test(password);
		return /\d/.test(password);
	}

	passdwordValidation(password) {
		this.checkPasswordLength(password);
		this.checkPasswordUppercase(password);
		this.checkPasswordLowercase(password);
		this.checkPasswordSpecial(password);
		this.checkPasswordNumber(password);
	}

	changePassword() {
		const old_password = this.password_details.old;
		const new_password = this.password_details.new;
		const confirm_password = this.password_details.confirm;

		if (old_password != '' && old_password != null) {
			this.password_details_errors.old = false;
		} else {
			this.password_details_errors.old = true;
		}

		if (
			new_password != '' &&
			new_password != null &&
			this.valid_password_length == true &&
			this.valid_password_uppercase == true &&
			this.valid_password_lowercase == true &&
			this.valid_password_special == true &&
			this.valid_password_number == true
		) {
			this.password_details_errors.new = false;
		} else {
			this.password_details_errors.new = true;
		}

		if (confirm_password != '' && confirm_password != null && confirm_password == new_password) {
			this.password_details_errors.confirm = false;
		} else {
			this.password_details_errors.confirm = true;
		}

		if (
			this.password_details_errors.old == false &&
			this.password_details_errors.new == false &&
			this.password_details_errors.confirm == false
		) {
			const payload = {
				current_password: this.encryptPassword(JSON.parse(JSON.stringify(old_password))),
				new_password: this.encryptPassword(JSON.parse(JSON.stringify(new_password))),
			};
			this.commonService.postData('/reset_password/', payload).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Password Updated Successfully.');
					this.password_details = {
						old: '',
						new: '',
						confirm: '',
					};
					this.password_details_errors = {
						old: false,
						new: false,
						confirm: false,
					};
				},
				(err) => {
					if (err.error.success == 0) {
						if (err.error.status == 'fail') {
							this.openPasswordExistModal();
						} else {
							this.commonService.showToast('error', err.error.error);
						}
					}
				},
			);
		}
	}

	encryptPassword(password: string): string {
		const ciphertext = CryptoJS.AES.encrypt(password, 'WealthGrowth-Secret-Key',).toString();
		return ciphertext;
	}

	@ViewChild('passwordExistModal') passwordExistModal: TemplateRef<any>;
	private passwordExistModalRef: MatDialogRef<TemplateRef<any>>;
	openPasswordExistModal() {
		this.passwordExistModalRef = this.dialog.open(this.passwordExistModal, { disableClose: true });
		this.passwordExistModalRef.afterClosed().subscribe((result) => {
			this.closePasswordExistModal();
		});
	}

	closePasswordExistModal() {
		this.passwordExistModalRef.close();
	}

	is_server_password_active: boolean = true;
	server_password: any = '';
	mail_info_data_errors: any = {
		server_type: false,
		server_username: false,
		server_password: false,
		server_hostname: false,
		server_incoming_port: false,
		server_outgoing_port: false,
	};

  	changeMailInformation() {
		if (this.user_details.server_type != '' && this.user_details.server_type != null) {
			this.mail_info_data_errors.server_type = false;
		} else {
			this.mail_info_data_errors.server_type = true;
		}

		if (this.user_details.server_username != '' && this.user_details.server_username != null && this.validEmail(this.user_details.server_username)) {
			this.mail_info_data_errors.server_username = false;
		} else {
			this.mail_info_data_errors.server_username = true;
		}

		if (this.server_password != '' && this.server_password != null) {
			this.mail_info_data_errors.server_password = false;
		} else {
			this.mail_info_data_errors.server_password = true;
		}

		if (this.user_details.server_hostname != '' && this.user_details.server_hostname != null) {
			this.mail_info_data_errors.server_hostname = false;
		} else {
			this.mail_info_data_errors.server_hostname = true;
		}

		if (this.user_details.server_incoming_port != '' && this.user_details.server_incoming_port != null) {
			this.mail_info_data_errors.server_incoming_port = false;
		} else {
			this.mail_info_data_errors.server_incoming_port = true;
		}

		if (this.user_details.server_outgoing_port != '' && this.user_details.server_outgoing_port != null) {
			this.mail_info_data_errors.server_outgoing_port = false;
		} else {
			this.mail_info_data_errors.server_outgoing_port = true;
		}

		if (
			this.mail_info_data_errors.server_type == false &&
			this.mail_info_data_errors.server_username == false &&
			this.mail_info_data_errors.server_password == false &&
			this.mail_info_data_errors.server_hostname == false &&
			this.mail_info_data_errors.server_incoming_port == false &&
			this.mail_info_data_errors.server_outgoing_port == false
		) {
			const payload = {
				server_type: this.user_details.server_type,
				server_username: this.user_details.server_username,
				server_password: this.server_password,
				server_hostname: this.user_details.server_hostname,
				server_incoming_port: this.user_details.server_incoming_port,
				server_outgoing_port: this.user_details.server_outgoing_port,
			};
			this.commonService.patch('/user/' + this.user_details.id + '/', payload).subscribe(
				(res: any) => {
					this.storageService.set('user_details', this.user_details);
					this.commonService.showToast('success', 'Mail Details Configured Successfully.');
					this.server_password = '';
					// this.datePipe.transform(this.user_details.date_of_birth, "MM/dd/yyyy");
				},
				(err) => {
					this.commonService.showToast('error', err.error.error);
				},
			);
		}
	}

	notification_info_data_errors: any = {
		notification_alerts: false,
		notification_frequency: false,
	};
	changeNotificationInformation() {
		if (this.user_details.notification_alerts && this.user_details.notification_alerts != '' && this.user_details.notification_alerts != null) {
			this.notification_info_data_errors.notification_alerts = false;
		} else {
			this.notification_info_data_errors.notification_alerts = true;
		}

		if (this.user_details.notification_frequency && this.user_details.notification_frequency != '' && this.user_details.notification_frequency != null) {
			this.notification_info_data_errors.notification_frequency = false;
		} else {
			this.notification_info_data_errors.notification_frequency = true;
		}

		if (
			this.notification_info_data_errors.notification_alerts == false &&
			this.notification_info_data_errors.notification_frequency == false
		) {
			const payload = {
				notification_alerts: this.user_details.notification_alerts,
				notification_frequency: this.user_details.notification_frequency,
			};
			this.commonService.patch('/user/' + this.user_details.id + '/', payload).subscribe(
				(res: any) => {
					this.storageService.set('user_details', this.user_details);
					this.commonService.showToast('success', 'Notification Details Configured Successfully.');
					this.server_password = '';
				},
				(err) => {
					this.commonService.showToast('error', err.error.error);
				},
			);
		}

	}

	changeNotificationConfigurationInformation() {
		if ((this.user_details.role.role == 3) && (this.user_details.escalate_reminder_count == 0 || this.user_details.escalate_overdue_days == 0)) {
			return false;
		}

		this.commonService.postData('/configurationsview/', this.user_details).subscribe(
			(res: any) => {
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', 'Notification Details Configured Successfully.');
				this.server_password = '';
			},
			(err) => {
				this.commonService.showToast('error', err.error.error);
			},
		);
	}

	profile_data_errors: any = {
		first_name: false,
		middle_name: false,
		last_name: false,
		email: false,
		phone_number: false,
		date_of_birth: false,
		address: false,
		city: false,
		state_id: false,
	};

	updateProfile() {
		if (this.user_details.first_name != "" && this.user_details.first_name != null) {
			this.profile_data_errors.first_name = false;
		} else {
			this.profile_data_errors.first_name = true;
		}

		// if (this.user_details.middle_name != "" && this.user_details.middle_name != null) {
		// 	this.profile_data_errors.middle_name = false;
		// } else {
		// 	this.profile_data_errors.middle_name = true;
		// }

		if (this.user_details.last_name != "" && this.user_details.last_name != null) {
			this.profile_data_errors.last_name = false;
		} else {
			this.profile_data_errors.last_name = true;
		}

		if (this.user_details.email != "" && this.user_details.email != null && this.validEmail(this.user_details.email)) {
			this.profile_data_errors.email = false;
		} else {
			this.profile_data_errors.email = true;
		}

		if (
      this.user_details.phone_number != "" &&
      this.user_details.phone_number != null &&
      this.user_details.phone_number.length >= APP_CONSTANTS.PHONE_NUMBER_LENGTH
      // &&
      // this.validatePhoneNumber(this.user_details.phone_number)
    ) {
			this.profile_data_errors.phone_number = false;
		} else {
			this.profile_data_errors.phone_number = true;
		}

		if (this.user_details.date_of_birth != "" && this.user_details.date_of_birth != null) {
			this.profile_data_errors.date_of_birth = false;
		} else {
			this.profile_data_errors.date_of_birth = true;
		}

		// if (this.user_details.address != "" && this.user_details.address != null) {
		// 	this.profile_data_errors.address = false;
		// } else {
		// 	this.profile_data_errors.address = true;
		// }

		// if (this.user_details.city != "" && this.user_details.city != null) {
		// 	this.profile_data_errors.city = false;
		// } else {
		// 	this.profile_data_errors.city = true;
		// }

		// if (this.user_details.state_id != "" && this.user_details.state_id != null) {
		// 	this.profile_data_errors.state_id = false;
		// } else {
		// 	this.profile_data_errors.state_id = true;
		// }

		if (
			this.profile_data_errors.first_name == false &&
			// this.profile_data_errors.middle_name == false &&
			this.profile_data_errors.last_name == false &&
			this.profile_data_errors.email == false &&
			this.profile_data_errors.phone_number == false &&
			this.profile_data_errors.date_of_birth == false
			// &&
			// this.profile_data_errors.address == false &&
			// this.profile_data_errors.city == false &&
			// this.profile_data_errors.state_id == false &&
		) {
			const payload: any = {
				id: this.user_details.id,
				first_name: this.user_details.first_name,
				last_name: this.user_details.last_name,
				email: this.user_details.email,
				phone_number: this.user_details.phone_number,
				date_of_birth: moment(this.user_details.date_of_birth).format(),
				address: this.user_details.address,
				city: this.user_details.city,
				state: this.user_details.state_id,
			};
			this.commonService.patch('/user/' + this.user_details.id + '/', payload).subscribe(
                (res: any) => {
					this.storageService.set('user_details', this.user_details);
					this.commonService.showToast('success', 'Profile Details Updated Successfully.');
					// this.datePipe.transform(this.user_details.date_of_birth, "MM/dd/yyyy");
                },
                (err) => {
                	this.commonService.showToast('error', err.error.error);
                },
            );
		}
	}

	advisor_data: any;
	advisor_data_errors: any = {};
	advisor_data_loaded: boolean = true;
	getAdvisorData() {
		this.advisor_data_loaded = false;
		this.commonService.getData('/advisordetails/?id=' + this.user_details.id).subscribe(
			(res: any) => {
				this.advisor_data = res;
				if (this.advisor_data.date_of_birth) {
					this.advisor_data.date_of_birth = this.datePipe.transform(this.advisor_data.date_of_birth, 'MM/dd/yyyy');
				}

				if (this.advisor_data.date_of_joining) {
					this.advisor_data.date_of_joining = this.datePipe.transform(this.advisor_data.date_of_joining, 'MM/dd/yyyy');
				}

				const data = Object.keys(this.advisor_data);
				for (let index = 0; index < data.length; index++) {
					const key = data[index];
					this.advisor_data_errors[key] = false
				}
				this.advisor_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error.error);
			},
		);
	}

	validateInputFields(fields, section) {
		for (let index = 0; index < fields.length; index++) {
			const data = this.advisor_data[fields[index]["key"]];
			if ((fields[index]["type"] == "text") || (fields[index]["type"] == "date")) {
				if (data != "" && data != null) {
					this.advisor_data_errors[fields[index]["key"]] = false;
				} else {
					this.advisor_data_errors[fields[index]["key"]] = true;
				}
			} else if (fields[index]["type"] == "email") {
				if (data != "" && data != null && this.validEmail(data)) {
					this.advisor_data_errors[fields[index]["key"]] = false;
				} else {
					this.advisor_data_errors[fields[index]["key"]] = true;
				}
			} else if (fields[index]["type"] == "phone_number") {
				// if (data != "" && data != null && this.validatePhoneNumber(data)) {
				if (data != "" && data != null && data.length >= APP_CONSTANTS.PHONE_NUMBER_LENGTH) {
					this.advisor_data_errors[fields[index]["key"]] = false;
				} else {
					this.advisor_data_errors[fields[index]["key"]] = true;
				}
			} else if (fields[index]["type"] == "multiselect") {
				if (data.length > 0) {
					this.advisor_data_errors[fields[index]["key"]] = false;
				} else {
					this.advisor_data_errors[fields[index]["key"]] = true;
				}
			}
		}

		for (let index = 0; index < fields.length; index++) {
			if (this.advisor_data_errors[fields[index]["key"]] == true) {
				if (section == "Personal Information") {
					this.invalid_personal_info = true;
				} else if (section == "Contact Information") {
					this.invalid_contact_info = true;
				} else if (section == "Experience Information") {
					this.invalid_experience_info = true;
				} else if (section == "Employment Information") {
					this.invalid_employment_info = true;
				}
				break;
			} else {
				if (section == "Personal Information") {
					this.invalid_personal_info = false;
				} else if (section == "Contact Information") {
					this.invalid_contact_info = false;
				} else if (section == "Experience Information") {
					this.invalid_experience_info = false;
				} else if (section == "Employment Information") {
					this.invalid_employment_info = false;
				}
			}
		}
	}

	toggle_personal_info: boolean = true;
	invalid_personal_info: boolean = false;
	validatePersonalInformation() {
		const fields = [
			{
				key: "advisor_id",
				type: "text"
	 		},
			 {
				key: "first_name",
				type: "text"
	 		},
			 {
				key: "last_name",
				type: "text"
	 		},
			{
				key: "email",
				type: "email"
	 		},
			{
				key: "gender_id",
				type: "text"
			},
			{
				key: "phone_number",
				type: "phone_number"
			},
			{
				key: "date_of_birth",
				type: "date"
			},
			{
				key: "advisor_status_id",
				type: "text"
			},
		];
		this.validateInputFields(fields, "Personal Information");
	}

	toggle_contact_info: boolean = false;
	invalid_contact_info: boolean = false;
	validateContactInformation() {
		const fields = [
			{
				key: "address_line_1",
				type: "text"
	 		},
			{
				key: "city",
				type: "text"
	 		},
			{
				key: "state_id",
				type: "text"
	 		},
			{
				key: "region_id",
				type: "text"
	 		},
			{
				key: "zip_code",
				type: "text"
	 		},
		];
		this.validateInputFields(fields, "Contact Information");
	}

	toggle_secondary_address: boolean = false;
	invalid_secondary_address_info: boolean = false;

	toggle_third_address: boolean = false;
	invalid_third_address_info: boolean = false;

	toggle_social_network: boolean = false;
	invalid_social_network_info: boolean = false;

	toggle_experience_info: boolean = false;
	invalid_experience_info: boolean = false;
	validateExperienceInformation() {
		const fields = [
			 {
				key: "total_experience",
				type: "text"
	 		},
			{
				key: "states_registered",
				type: "multiselect"
	 		},
			{
				key: "certificates",
				type: "multiselect"
			},
			{
				key: "professional_associations",
				type: "multiselect"
			},
		];
		this.validateInputFields(fields, "Experience Information");
	}

	toggle_employment_info: boolean = false;
	invalid_employment_info: boolean = false;
	validateEmploymentInformation() {
		const fields = [
			 {
				key: "financial_institution_branch",
				type: "text"
	 		},
			{
				key: "date_of_joining",
				type: "date"
	 		},
		];
		this.validateInputFields(fields, "Employment Information");
	}

	toggle_past_experience_info: boolean = false;
	invalid_past_experience_info: boolean = false;

	toggle_services_info: boolean = false;
	invalid_services_info: boolean = false;

	updateAdvisorProfile() {
		this.validatePersonalInformation();
		this.validateContactInformation();
		this.validateExperienceInformation();
		this.validateEmploymentInformation();
		if (
			this.invalid_personal_info == false &&
			this.invalid_contact_info == false &&
			this.invalid_experience_info == false &&
			this.invalid_employment_info == false
		) {
			let payload: any = JSON.parse(JSON.stringify(this.advisor_data));

			if (this.advisor_data.employment_details && this.advisor_data.employment_details.length > 0) {
				for (let index = 0; index < this.advisor_data.employment_details.length; index++) {
					this.advisor_data.employment_details[index].start_date = this.datePipe.transform(this.advisor_data.employment_details[index].start_date, 'yyyy-MM-dd');
					this.advisor_data.employment_details[index].end_date = this.datePipe.transform(this.advisor_data.employment_details[index].end_date, 'yyyy-MM-dd');
				}
			}

			payload.date_of_birth = this.datePipe.transform(payload.date_of_birth, 'yyyy-MM-dd');
			payload.date_of_joining = this.datePipe.transform(payload.date_of_joining, 'yyyy-MM-dd');


			this.commonService.updateData('/advisor/' + payload.id + '/', payload).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Advisor has been updated successfully.');
					this.getAdvisorData();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);

		}
	}

	experience_data: any = {
		prior_employment_id: "",
		company_name: "",
		start_date: "",
		end_date: "",
		work_years: "",
	};
	experience_data_errors: any = {
		prior_employment_id: false,
		company_name: false,
		start_date: false,
		end_date: false,
		work_years: false,
	};
	experience_data_operation_type: any = "Add";
	experience_data_operation_index: any = null;

	@ViewChild('experienceOperationModal') experienceOperationModal: TemplateRef<any>;
	private experienceOperationModalRef: MatDialogRef<TemplateRef<any>>;
	openExperienceOperationModal(data, type, index) {
		this.experience_data = JSON.parse(JSON.stringify(data));
		this.experience_data_operation_type = type;
		this.experience_data_operation_index = index;

		if (this.experience_data_operation_type == "Edit") {
			this.experience_data.start_date = this.datePipe.transform(this.experience_data.start_date, 'MM-dd-yyyy');
			this.experience_data.end_date = this.datePipe.transform(this.experience_data.end_date, 'MM-dd-yyyy');
		}

		this.experienceOperationModalRef = this.dialog.open(this.experienceOperationModal, { disableClose: true });
		this.experienceOperationModalRef.afterClosed().subscribe((result) => {
			this.closeExperienceOperationModal();
		});
	}

	closeExperienceOperationModal() {
		this.experienceOperationModalRef.close();
		this.resetExperienceData();
	}

	saveExperience() {
		if (this.experience_data.prior_employment_id != "" && this.experience_data.prior_employment_id != null) {
			this.experience_data_errors.prior_employment_id = false;
		} else {
			this.experience_data_errors.prior_employment_id = true;
		}

		if (this.experience_data.company_name != "" && this.experience_data.company_name != null) {
			this.experience_data_errors.company_name = false;
		} else {
			this.experience_data_errors.company_name = true;
		}

		if (this.experience_data.start_date != "" && this.experience_data.start_date != null) {
			this.experience_data_errors.start_date = false;
		} else {
			this.experience_data_errors.start_date = true;
		}

		if (this.experience_data.end_date != "" && this.experience_data.end_date != null) {
			this.experience_data_errors.end_date = false;
		} else {
			this.experience_data_errors.end_date = true;
		}

		if (this.experience_data.work_years != "" && this.experience_data.work_years != null) {
			this.experience_data_errors.work_years = false;
		} else {
			this.experience_data_errors.work_years = true;
		}

		if (
			this.experience_data_errors.prior_employment_id == false &&
			this.experience_data_errors.company_name == false &&
			this.experience_data_errors.start_date == false &&
			this.experience_data_errors.end_date == false &&
			this.experience_data_errors.work_years == false
		) {
			if (this.experience_data_operation_type == "Add") {
				if (!this.advisor_data.employment_details) {
					this.advisor_data.employment_details = [];
				}
				this.experience_data.start_date = this.datePipe.transform(this.experience_data.start_date, 'yyyy-MM-dd');
				this.experience_data.end_date = this.datePipe.transform(this.experience_data.end_date, 'yyyy-MM-dd');
				this.advisor_data.employment_details.push(this.experience_data);
				this.closeExperienceOperationModal();
			} else if (this.experience_data_operation_type == "Edit") {
				this.advisor_data.employment_details.splice(this.experience_data_operation_index, 1, this.experience_data);
				this.closeExperienceOperationModal();
			}
		}
	}

	@ViewChild('experienceDeleteModal') experienceDeleteModal: TemplateRef<any>;
	private experienceDeleteModalRef: MatDialogRef<TemplateRef<any>>;
	openDeleteExperienceModal(data, index) {
		this.experience_data = JSON.parse(JSON.stringify(data));
		this.experience_data_operation_index = index;
		this.experienceDeleteModalRef = this.dialog.open(this.experienceDeleteModal, { disableClose: true });
		this.experienceDeleteModalRef.afterClosed().subscribe((result) => {
			this.closeDeleteExperienceModal();
		});
	}

	closeDeleteExperienceModal() {
		this.experienceDeleteModalRef.close();
		this.resetExperienceData();
	}

	resetExperienceData() {
		this.experience_data = {
			prior_employment_id: "",
			company_name: "",
			start_date: "",
			end_date: "",
			work_years: "",
		};
		this.experience_data_errors = {
			prior_employment_id: false,
			company_name: false,
			start_date: false,
			end_date: false,
			work_years: false,
		};
		this.experience_data_operation_type = "Add";
		this.experience_data_operation_index = null;
	}

	deleteExperience() {
		this.advisor_data.employment_details.splice(this.experience_data_operation_index, 1);
		this.closeDeleteExperienceModal();
	}

	service_data: any = {
		name: "",
		type: "",
		cost: "",
		duration: "",
		services_offered: [],
		description: "",
	  };
	  service_data_errors: any = {
		name: false,
		type: false,
		cost: false,
		duration: false,
		services_offered: false,
		description: false,
	  };
	  services_operation_type: any = "Add";


	  resetServiceData() {
		this.service_data = {
		  name: "",
		  type: "",
		  cost: "",
		  duration: "",
		  services_offered: [],
		  description: "",
		};
		this.service_data_errors = {
		  name: false,
		  type: false,
		  cost: false,
		  duration: false,
		  services_offered: false,
		  description: false,
		};
		this.services_operation_type = "Add";
	  }

	  @ViewChild('serviceOperationsModal') serviceOperationsModal: TemplateRef<any>;
	  private serviceOperationsModalRef: MatDialogRef<TemplateRef<any>>;
	  openServiceOperationModal(data, type) {
		this.service_data = JSON.parse(JSON.stringify(data));
		this.services_operation_type = type;
		this.serviceOperationsModalRef = this.dialog.open(this.serviceOperationsModal, { disableClose: true });
		this.serviceOperationsModalRef.afterClosed().subscribe((result) => {
		  this.closeServiceOperationsModal();
		});
	  }

	  closeServiceOperationsModal() {
		this.resetServiceData();
		this.serviceOperationsModalRef.close();
	  }

	  saveServiceData() {

		if (
		  this.service_data.name != "" &&
		  this.service_data.name != null
		) {
		  this.service_data_errors.name = false;
		} else {
		  this.service_data_errors.name = true;
		}

		if (
		  this.service_data.type != "" &&
		  this.service_data.type != null
		) {
		  this.service_data_errors.type = false;
		} else {
		  this.service_data_errors.type = true;
		}

		if (
		  this.service_data.cost != "" &&
		  this.service_data.cost != null
		) {
		  this.service_data_errors.cost = false;
		} else {
		  this.service_data_errors.cost = true;
		}

		if (
		  this.service_data.duration != "" &&
		  this.service_data.duration != null
		) {
		  this.service_data_errors.duration = false;
		} else {
		  this.service_data_errors.duration = true;
		}

		if (
		  this.service_data.services_offered.length > 0
		) {
		  this.service_data_errors.services_offered = false;
		} else {
		  this.service_data_errors.services_offered = true;
		}

		// if (
		//   this.service_data.description != "" &&
		//   this.service_data.description != null
		// ) {
		//   this.service_data_errors.description = false;
		// } else {
		//   this.service_data_errors.description = true;
		// }

		if (
		  this.service_data_errors.name == false &&
		  this.service_data_errors.type == false &&
		  this.service_data_errors.cost == false &&
		  this.service_data_errors.duration == false &&
		  this.service_data_errors.services_offered == false
		  // &&
		  // this.page_data_record_errors.description == false
		) {
		  let payload: any = this.service_data;
		  payload.advisor = this.advisor_data.id;
		  if (this.services_operation_type == 'Add') {
			this.commonService
			  .postData('/services', payload)
			  .subscribe(
				(res: any) => {
				  this.advisor_data.services.push(res);
				  this.commonService.showToast(
					'success',
					'Service Added Successfully.',
				  );
				  this.closeServiceOperationsModal();
				},
				(err) => {
				  this.commonService.showToast('error', err.error);
				},
			  );
		  } else if (this.services_operation_type == 'Edit') {
			this.commonService
			  .patch(
				'/services/' + payload.id,
				payload,
			  )
			  .subscribe(
				(res: any) => {
				  const index = this.advisor_data.services.findIndex(
					(x) => x.id == this.service_data.id,
				  );
				  this.advisor_data.services.splice(index, 1, res);
				  this.commonService.showToast(
					'success',
					'Service Updated Successfully.',
				  );
				  this.closeServiceOperationsModal();
				},
				(err) => {
				  this.commonService.showToast('error', err.error);
				},
			  );
		  }
		}
	  }

	  @ViewChild('serviceDeleteModal') serviceDeleteModal: TemplateRef<any>;
	  private serviceDeleteModalRef: MatDialogRef<TemplateRef<any>>;

	  deleteService(data) {
		this.service_data = JSON.parse(JSON.stringify(data));
		this.serviceDeleteModalRef = this.dialog.open(this.serviceDeleteModal, { disableClose: true });
		this.serviceDeleteModalRef.afterClosed().subscribe((result) => {
		  this.closeDeleteServiceModal();
		});
	  }

	  closeDeleteServiceModal() {
		this.resetServiceData();
		this.serviceDeleteModalRef.close();
	  }

	  deleteServiceDetails() {
		const payload = [this.service_data.id];
		this.commonService.delete('/services/destroy?ids=' + payload).subscribe(
		  (res: any) => {
			this.commonService.showToast(
			  'success',
			  'Service Deleted Successfully.',
			);

			const index = this.advisor_data.services.findIndex(
			  (x) => x.id == this.service_data.id,
			);
			this.advisor_data.services.splice(index, 1);

			this.closeDeleteServiceModal();
		  },
		  (err) => {
			this.commonService.showToast('error', err.error);
		  },
		);
	  }

	  toggle_zoom_integration: boolean = false;
	  connect_zoom_loader: boolean = false;
	  connectZoom() {
		this.connect_zoom_loader = true;
		this.commonService.getData('/zoomauth/?return_url=' + this.current_url).subscribe(
			(res: any) => {
			  window.location.href = res;
			  this.connect_zoom_loader = false;
			},
			(err) => {
			  this.commonService.showToast('error', err.error);
			  this.connect_zoom_loader = false;
			},
		  );
	  }

	  disconnectZoom() {
		const payload = {
			app_type: "Zoom_connected"
		};
		this.commonService.postData('/disconnectintegration/', payload).subscribe(
			(res: any) => {
				this.user_details.Zoom_connected = !this.user_details.Zoom_connected;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', "Zoom has been disconnected");
			},
			(err) => {
			  this.commonService.showToast('error', err.error);
			},
		  );
	  }

    toggle_google_integration: boolean = false;
    connect_google_loader: boolean = false;
    connectGoogle() {
    this.connect_google_loader = true;
    this.commonService.getData('/googleauth/?return_url=' + this.current_url).subscribe(
      (res: any) => {
        window.location.href = res;
        this.connect_google_loader = false;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
        this.connect_google_loader = false;
      },
      );
    }

    disconnectGoogle() {
      const payload = {
        app_type: "Google_Meet_connected"
      };
      this.commonService.postData('/disconnectintegration/', payload).subscribe(
        (res: any) => {
          this.user_details.Google_Meet_connected = !this.user_details.Google_Meet_connected;
          this.storageService.set('user_details', this.user_details);
          this.commonService.showToast('success', "Google Meet has been disconnected");
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
        );
    }


	  toggle_salesforce_integration: boolean = false;

	  connect_salesforce_loader: boolean = false;
	  connectSalesforce() {
		this.connect_salesforce_loader = true;
		this.commonService.getData('/salesforceauth/?return_url=' + this.current_url).subscribe(
			(res: any) => {
			  	window.location.href = res;
				this.connect_salesforce_loader = false;
			},
			(err) => {
			  	this.commonService.showToast('error', err.error);
				this.connect_salesforce_loader = false;
			},
		  );
	  }

	  disconnectSalesforce() {
		const payload = {
			app_type: "Salesforce_connected"
		};
		this.commonService.postData('/disconnectintegration/', payload).subscribe(
			(res: any) => {
				this.user_details.Salesforce_connected = !this.user_details.Salesforce_connected;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', "Salesforce has been disconnected");
			},
			(err) => {
			  this.commonService.showToast('error', err.error);
			},
		  );
	  }

    toggle_linkedin_integration: boolean = false;

	  connect_linkedin_loader: boolean = false;
	  connectLinkedin() {
		this.connect_linkedin_loader = true;
		this.commonService.getData('/linkedinauth/?return_url=' + this.current_url).subscribe(
			(res: any) => {
			  	window.location.href = res;
				this.connect_linkedin_loader = false;
			},
			(err) => {
			  	this.commonService.showToast('error', err.error);
				this.connect_linkedin_loader = false;
			},
		  );
	  }

    disconnectLinkedin() {
      const payload = {
        app_type: "Linkedin_connected"
      };
      this.commonService.postData('/disconnectintegration/', payload).subscribe(
        (res: any) => {
          this.user_details.Linkedin_connected = !this.user_details.Linkedin_connected;
          this.storageService.set('user_details', this.user_details);
          this.commonService.showToast('success', "Linkedin has been disconnected");
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
        );
    }

	@ViewChild('connectCalenderIntegrationModal') connectCalenderIntegrationModal: TemplateRef<any>;
	private connectCalenderIntegrationModalRef: MatDialogRef<TemplateRef<any>>;

	calender_integration_type_id: any = "";
	calender_integration_type: any = "";
	calender_integration_user_key: any = "";
	calender_integration_type_error: boolean = false;
	openconnectCalenderIntegration(id, name, user_key) {
		this.calender_integration_type = JSON.parse(JSON.stringify(name));
		this.calender_integration_type_id = JSON.parse(JSON.stringify(id));
		this.calender_integration_user_key = JSON.parse(JSON.stringify(user_key));

		this.connectCalenderIntegrationModalRef = this.dialog.open(this.connectCalenderIntegrationModal, { disableClose: true });
		this.connectCalenderIntegrationModalRef.afterClosed().subscribe((result) => {
		  this.closeconnectCalenderIntegration();
		});

	}

	closeconnectCalenderIntegration() {
		this.connectCalenderIntegrationModalRef.close();
		this.calender_integration_type_id = "";
		this.calender_integration_type = "";
		this.calender_integration_user_key = "";
		this.calender_integration_type_error = false;
		this.calender_integration_link = "";
		this.calender_integration_link_error = false;
    this.calender_api_key = "";
		this.calender_api_key_error = false;
	}

	validateURL(url) {
		const regex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
		return regex.test(url);
	}

	calender_integration_link: any = "";
	calender_integration_link_error: boolean = false;
  calender_api_key: any = "";
	calender_api_key_error: boolean = false;
	connectCalenderIntegration() {
		if (this.calender_integration_link != "" && this.calender_integration_link != null && this.validateURL(this.calender_integration_link)) {
			this.calender_integration_link_error = false;
		} else {
			this.calender_integration_link_error = true;
		}

    if (this.calender_api_key != "" && this.calender_api_key != null) {
			this.calender_api_key_error = false;
		} else {
			this.calender_api_key_error = true;
		}

		if (this.calender_integration_link_error == false && this.calender_api_key_error == false) {
			const payload = {
				booking_url: this.calender_integration_link,
				api_key: this.calender_api_key,
				app_type: this.calender_integration_type_id
			};
			this.commonService.postData('/connectMeetingScheduler/', payload).subscribe(
				(res: any) => {
					this.user_details[this.calender_integration_user_key]= true;
					this.storageService.set('user_details', this.user_details);
					this.commonService.showToast('success', this.calender_integration_type + " has been disconnected");
					this.closeconnectCalenderIntegration();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}

	}

	disConnectCalenderIntegration(type, name) {
		const payload = {
			app_type: type
		};
		this.commonService.postData('/disconnectintegration/', payload).subscribe(
			(res: any) => {
				this.user_details[type]= false;
				this.storageService.set('user_details', this.user_details);
				this.commonService.showToast('success', name + " has been disconnected");
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	time_slots_list: any = [];
	generateTimeSlots() {
		this.time_slots_list = [];

		for (let hour = 0; hour < 24; hour++) {
			for (let minute = 0; minute < 60; minute += 30) {
				const h = hour.toString().padStart(2, '0');
				const m = minute.toString().padStart(2, '0');
				this.time_slots_list.push(`${h}:${m}`);
			}
		}
	}

	timezone_list: any = [];
	generateTimeZones() {
		const timeZonesObject = {
			"Pacific/Midway": "(GMT-11:00) Midway Island, Samoa",
			"Pacific/Pago_Pago": "(GMT-11:00) Pago Pago",
			"Pacific/Honolulu": "(GMT-10:00) Hawaii",
			"America/Anchorage": "(GMT-8:00) Alaska",
			"America/Juneau": "(GMT-8:00) Juneau",
			"America/Vancouver": "(GMT-7:00) Vancouver",
			"America/Los_Angeles": "(GMT-7:00) Pacific Time (US and Canada)",
			"America/Tijuana": "(GMT-7:00) Tijuana",
			"America/Phoenix": "(GMT-7:00) Arizona",
			"America/Edmonton": "(GMT-6:00) Edmonton",
			"America/Denver": "(GMT-6:00) Mountain Time (US and Canada)",
			"America/Mazatlan": "(GMT-6:00) Mazatlan",
			"America/Regina": "(GMT-6:00) Saskatchewan",
			"America/Guatemala": "(GMT-6:00) Guatemala",
			"America/El_Salvador": "(GMT-6:00) El Salvador",
			"America/Managua": "(GMT-6:00) Managua",
			"America/Costa_Rica": "(GMT-6:00) Costa Rica",
			"America/Tegucigalpa": "(GMT-6:00) Tegucigalpa",
			"America/Chihuahua": "(GMT-6:00) Chihuahua",
			"America/Winnipeg": "(GMT-5:00) Winnipeg",
			"America/Chicago": "(GMT-5:00) Central Time (US and Canada)",
			"America/Mexico_City": "(GMT-5:00) Mexico City",
			"America/Panama": "(GMT-5:00) Panama",
			"America/Bogota": "(GMT-5:00) Bogota",
			"America/Lima": "(GMT-5:00) Lima",
			"America/Monterrey": "(GMT-5:00) Monterrey",
			"America/Montreal": "(GMT-4:00) Montreal",
			"America/New_York": "(GMT-4:00) Eastern Time (US and Canada)",
			"America/Indianapolis": "(GMT-4:00) Indiana (East)",
			"America/Puerto_Rico": "(GMT-4:00) Puerto Rico",
			"America/Caracas": "(GMT-4:00) Caracas",
			"America/Santiago": "(GMT-4:00) Santiago",
			"America/La_Paz": "(GMT-4:00) La Paz",
			"America/Guyana": "(GMT-4:00) Guyana",
			"America/Halifax": "(GMT-3:00) Halifax",
			"America/Montevideo": "(GMT-3:00) Montevideo",
			"America/Araguaina": "(GMT-3:00) Recife",
			"America/Argentina/Buenos_Aires": "(GMT-3:00) Buenos Aires, Georgetown",
			"America/Sao_Paulo": "(GMT-3:00) Sao Paulo",
			"Canada/Atlantic": "(GMT-3:00) Atlantic Time (Canada)",
			"America/St_Johns": "(GMT-2:30) Newfoundland and Labrador",
			"America/Godthab": "(GMT-2:00) Greenland",
			"Atlantic/Cape_Verde": "(GMT-1:00) Cape Verde Islands",
			"Atlantic/Azores": "(GMT+0:00) Azores",
			"UTC": "(GMT+0:00) Universal Time UTC",
			"Etc/Greenwich": "(GMT+0:00) Greenwich Mean Time",
			"Atlantic/Reykjavik": "(GMT+0:00) Reykjavik",
			"Africa/Casablanca": "(GMT+0:00) Casablanca",
			"Africa/Nouakchott": "(GMT+0:00) Nouakchott",
			"Europe/Dublin": "(GMT+1:00) Dublin",
			"Europe/London": "(GMT+1:00) London",
			"Europe/Lisbon": "(GMT+1:00) Lisbon",
			"Africa/Bangui": "(GMT+1:00) West Central Africa",
			"Africa/Algiers": "(GMT+1:00) Algiers",
			"Africa/Tunis": "(GMT+1:00) Tunis",
			"Europe/Belgrade": "(GMT+2:00) Belgrade, Bratislava, Ljubljana",
			"CET": "(GMT+2:00) Sarajevo, Skopje, Zagreb",
			"Europe/Oslo": "(GMT+2:00) Oslo",
			"Europe/Copenhagen": "(GMT+2:00) Copenhagen",
			"Europe/Brussels": "(GMT+2:00) Brussels",
			"Europe/Berlin": "(GMT+2:00) Amsterdam, Berlin, Rome, Stockholm, Vienna",
			"Europe/Amsterdam": "(GMT+2:00) Amsterdam",
			"Europe/Rome": "(GMT+2:00) Rome",
			"Europe/Stockholm": "(GMT+2:00) Stockholm",
			"Europe/Vienna": "(GMT+2:00) Vienna",
			"Europe/Luxembourg": "(GMT+2:00) Luxembourg",
			"Europe/Paris": "(GMT+2:00) Paris",
			"Europe/Zurich": "(GMT+2:00) Zurich",
			"Europe/Madrid": "(GMT+2:00) Madrid",
			"Africa/Harare": "(GMT+2:00) Harare, Pretoria",
			"Europe/Warsaw": "(GMT+2:00) Warsaw",
			"Europe/Prague": "(GMT+2:00) Prague Bratislava",
			"Europe/Budapest": "(GMT+2:00) Budapest",
			"Africa/Tripoli": "(GMT+2:00) Tripoli",
			"Africa/Cairo": "(GMT+2:00) Cairo",
			"Africa/Johannesburg": "(GMT+2:00) Johannesburg",
			"Africa/Khartoum": "(GMT+2:00) Khartoum",
			"Europe/Helsinki": "(GMT+3:00) Helsinki",
			"Africa/Nairobi": "(GMT+3:00) Nairobi",
			"Europe/Sofia": "(GMT+3:00) Sofia",
			"Europe/Istanbul": "(GMT+3:00) Istanbul",
			"Europe/Athens": "(GMT+3:00) Athens",
			"Europe/Bucharest": "(GMT+3:00) Bucharest",
			"Asia/Nicosia": "(GMT+3:00) Nicosia",
			"Asia/Beirut": "(GMT+3:00) Beirut",
			"Asia/Damascus": "(GMT+3:00) Damascus",
			"Asia/Jerusalem": "(GMT+3:00) Jerusalem",
			"Asia/Amman": "(GMT+3:00) Amman",
			"Europe/Moscow": "(GMT+3:00) Moscow",
			"Asia/Baghdad": "(GMT+3:00) Baghdad",
			"Asia/Kuwait": "(GMT+3:00) Kuwait",
			"Asia/Riyadh": "(GMT+3:00) Riyadh",
			"Asia/Bahrain": "(GMT+3:00) Bahrain",
			"Asia/Qatar": "(GMT+3:00) Qatar",
			"Asia/Aden": "(GMT+3:00) Aden",
			"Africa/Djibouti": "(GMT+3:00) Djibouti",
			"Africa/Mogadishu": "(GMT+3:00) Mogadishu",
			"Europe/Kiev": "(GMT+3:00) Kiev",
			"Europe/Minsk": "(GMT+3:00) Minsk",
			"Asia/Dubai": "(GMT+4:00) Dubai",
			"Asia/Muscat": "(GMT+4:00) Muscat",
			"Asia/Baku": "(GMT+4:00) Baku, Tbilisi, Yerevan",
			"Asia/Tehran": "(GMT+4:30) Tehran",
			"Asia/Kabul": "(GMT+4:30) Kabul",
			"Asia/Yekaterinburg": "(GMT+5:00) Yekaterinburg",
			"Asia/Tashkent": "(GMT+5:00) Islamabad, Karachi, Tashkent",
			"Asia/Calcutta": "(GMT+5:30) India",
			"Asia/Kolkata": "(GMT+5:30) Mumbai, Kolkata, New Delhi",
			"Asia/Colombo": "(GMT+5:30) Asia/Colombo",
			"Asia/Kathmandu": "(GMT+5:45) Kathmandu",
			"Asia/Almaty": "(GMT+6:00) Almaty",
			"Asia/Dacca": "(GMT+6:00) Dacca",
			"Asia/Dhaka": "(GMT+6:00) Astana, Dhaka",
			"Asia/Rangoon": "(GMT+6:30) Rangoon",
			"Asia/Novosibirsk": "(GMT+7:00) Novosibirsk",
			"Asia/Krasnoyarsk": "(GMT+7:00) Krasnoyarsk",
			"Asia/Bangkok": "(GMT+7:00) Bangkok",
			"Asia/Saigon": "(GMT+7:00) Vietnam",
			"Asia/Jakarta": "(GMT+7:00) Jakarta",
			"Asia/Irkutsk": "(GMT+8:00) Irkutsk, Ulaanbaatar",
			"Asia/Shanghai": "(GMT+8:00) Beijing, Shanghai",
			"Asia/Hong_Kong": "(GMT+8:00) Hong Kong SAR",
			"Asia/Taipei": "(GMT+8:00) Taipei",
			"Asia/Kuala_Lumpur": "(GMT+8:00) Kuala Lumpur",
			"Asia/Singapore": "(GMT+8:00) Singapore",
			"Australia/Perth": "(GMT+8:00) Perth",
			"Asia/Yakutsk": "(GMT+9:00) Yakutsk",
			"Asia/Seoul": "(GMT+9:00) Seoul",
			"Asia/Tokyo": "(GMT+9:00) Osaka, Sapporo, Tokyo",
			"Australia/Darwin": "(GMT+9:30) Darwin",
			"Australia/Adelaide": "(GMT+9:30) Adelaide",
			"Asia/Vladivostok": "(GMT+10:00) Vladivostok",
			"Pacific/Port_Moresby": "(GMT+10:00) Guam, Port Moresby",
			"Australia/Brisbane": "(GMT+10:00) Brisbane",
			"Australia/Sydney": "(GMT+10:00) Canberra, Melbourne, Sydney",
			"Australia/Hobart": "(GMT+10:00) Hobart",
			"Asia/Magadan": "(GMT+11:00) Magadan",
			"SST": "(GMT+11:00) Solomon Islands",
			"Pacific/Noumea": "(GMT+11:00) New Caledonia",
			"Asia/Kamchatka": "(GMT+12:00) Kamchatka",
			"Pacific/Fiji": "(GMT+12:00) Fiji Islands, Marshall Islands",
			"Pacific/Auckland": "(GMT+12:00) Auckland, Wellington",
			"Pacific/Apia": "(GMT+13:00) Independent State of Samoa"
		};

		this.timezone_list = [];

		this.timezone_list = Object.keys(timeZonesObject).map(key => {
			return { value: key, name: `${key} : ${timeZonesObject[key]}` };
		});

	}

}
